import { Kip } from '../types';
import { mockClientProfiles } from './clients';

export const mockKips: Kip[] = [
  {
    id: '1',
    title: 'Explaining ABA Basics to Guardians',
    description: 'Introduce the core principles of Applied Behavior Analysis to a guardian before intake.',
    category: 'Education',
    duration: '~5 min',
    completed: true,
    score: 4,
    date: '2025-08-01',
    client: mockClientProfiles[0],
    guardianId: '1',
    agentId: 'agent_9701k1p7krvrecath1wvqz5mv9ar',
    availability: 'available',
  },
  {
    id: '2',
    title: 'Reviewing Intake Assessment Results',
    description: 'Discuss the outcomes of the intake assessment and outline next steps with the guardian.',
    category: 'Education',
    duration: '~7 min',
    completed: true,
    score: 5,
    date: '2025-08-01',
    client: mockClientProfiles[0],
    guardianId: '1',
    agentId: 'agent_9701k1p7krvrecath1wvqz5mv9ar',
    availability: 'available',
  },
  {
    id: '3',
    title: '30-Day Progress Update',
    description: 'Provide a comprehensive progress report to the guardian after 30 days of services.',
    category: 'Progress',
    duration: '~10 min',
    completed: true,
    score: 3,
    date: '2025-07-22',
    client: mockClientProfiles[1],
    guardianId: '2',
    agentId: 'agent_9701k1p7krvrecath1wvqz5mv9ar',
    availability: 'coming_soon',
  },
  {
    id: '4',
    title: 'Collaborative Planning with Colleague',
    description: 'Coordinate with a fellow therapist to plan upcoming behavior intervention strategies.',
    category: 'Collaboration',
    duration: '~8 min',
    completed: false,
    date: '',
    client: null,
    guardianId: null,
    agentId: 'agent_9701k1p7krvrecath1wvqz5mv9ar',
    availability: 'coming_soon',
  },
  {
    id: '7',
    title: 'Insurance Authorization Review',
    description: 'Present treatment progress and justify continued ABA services to insurance case manager.',
    category: 'Collaboration',
    duration: '~15 min',
    completed: true,
    score: 4,
    date: '2025-07-30',
    client: mockClientProfiles[0],
    guardianId: null,
    colleagueId: '2',
    agentId: 'agent_3c5e7g9i1kmoqsuw4y6a8c0e2g',
    availability: 'available',
  },
  {
    id: '8',
    title: 'IEP Team Meeting Collaboration',
    description: 'Collaborate with school psychologist to align ABA goals with educational objectives.',
    category: 'Collaboration',
    duration: '~20 min',
    completed: false,
    client: mockClientProfiles[1],
    guardianId: null,
    colleagueId: '3',
    agentId: 'agent_3c5e7g9i1kmoqsuw4y6a8c0e2g',
    availability: 'coming_soon',
  },
  {
    id: '9',
    title: 'Medical Team Consultation',
    description: 'Provide behavioral progress update to pediatric neurologist for comprehensive care coordination.',
    category: 'Collaboration',
    duration: '~12 min',
    completed: true,
    score: 5,
    date: '2024-02-02',
    client: mockClientProfiles[0],
    guardianId: null,
    colleagueId: '4',
    agentId: 'agent_3c5e7g9i1kmoqsuw4y6a8c0e2g',
    availability: 'available',
  },
  {
    id: '10',
    title: 'Peer Supervision Session',
    description: 'Discuss challenging cases and intervention strategies with senior BCBA colleague.',
    category: 'Education',
    duration: '~25 min',
    completed: false,
    client: null,
    guardianId: null,
    colleagueId: '1',
    agentId: 'agent_3c5e7g9i1kmoqsuw4y6a8c0e2g',
    availability: 'coming_soon',
  },
  {
    id: '5',
    title: 'Crisis De-escalation Training',
    description: 'Practice managing a behavioral crisis situation with appropriate intervention techniques.',
    category: 'Communication',
    duration: '~12 min',
    completed: true,
    score: 4,
    date: '2025-07-25',
    client: mockClientProfiles[0],
    guardianId: '1',
    agentId: 'agent_9701k1p7krvrecath1wvqz5mv9ar',
    availability: 'available',
  },
  {
    id: '6',
    title: 'Data Collection Accuracy Check',
    description: 'Review and practice proper data collection techniques during therapy sessions.',
    category: 'Accuracy',
    duration: '~6 min',
    completed: true,
    score: 5,
    date: '2025-07-28',
    client: mockClientProfiles[1],
    guardianId: '2',
    agentId: 'agent_5f7h9j1l3nprstvw2x4z6b8d0f',
    availability: 'coming_soon',
  },
];